import React, { useCallback, useState, useEffect } from "react";
import { Auth } from 'aws-amplify';
import { loadStripe } from "@stripe/stripe-js";
import { EmbeddedCheckoutProvider, EmbeddedCheckout } from "@stripe/react-stripe-js";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { Signer } from '@aws-amplify/core';


const StripeCheckoutSuccessPage = () => {
  const [status, setStatus] = useState(null);
  const [sessionId, setSessionId] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const sessionId = urlParams.get("session_id");
        setSessionId(sessionId);

        const credentials = await Auth.currentCredentials();
        
        const endpoint = "https://6wazxihgrbnhxgfkriil7soe6i0tiloy.lambda-url.us-east-1.on.aws";
        const sessionPayload = JSON.stringify({ session_id: sessionId })
        const serviceInfo = {
          service: 'lambda',
          region: 'us-east-1'
        };

        const signedRequest = await Signer.sign(
          {
            url: endpoint,
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            data: sessionPayload,
          },
          {
            access_key: credentials.accessKeyId,
            secret_key: credentials.secretAccessKey,
            session_token: credentials.sessionToken,
          },
          serviceInfo
        );
        
        const response = await fetch(signedRequest.url, {
          method: "POST",
          headers: signedRequest.headers,
          body: sessionPayload,
        });

        const data = await response.json();
        setStatus(data.status);
      } catch (error) {
        console.error('Error fetching session data:', error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (status === "open") {
      navigate("/checkout");
    } else if (status === "complete") {
      navigate(`/products?checkout=${sessionId}`);
    }
  }, [status, navigate]);

  return null;

};

export default StripeCheckoutSuccessPage;
